export default __webpack_public_path__ + "static/media/wallet-ico.3758c7ec.svg";